import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'o-p-r',
  templateUrl: './o-pr.component.html',
  styleUrls: ['./o-pr.component.scss']
})
export class OPRComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
